/**
 * Logger for printing output to console
 *
 */

const isLoggingEnabled =
  process.env.REACT_APP_LOGGING_ENABLED &&
  process.env.REACT_APP_LOGGING_ENABLED.trim().includes('true');

/**
 * "INFO" type logging function
 * @param args arguments to print
 */
function i(...args: unknown[]) {
  if (isLoggingEnabled) {
    console.log(args.length !== 0 ? (args.length > 1 ? args : args[0]) : '');
  }
}

/**
 * "ERROR" type logging function
 * @param args arguments to print
 */
const e = (...args: unknown[]) => {
  if (isLoggingEnabled) {
    console.error(args.length !== 0 ? (args.length > 1 ? args : args[0]) : '');
  }
};

/**
 * Array type logging function
 * @param array any array
 */
const arr = (array: unknown[]) => {
  if (isLoggingEnabled) {
    console.table(array);
  }
};

const logger = {
  i,
  e,
  arr,
};

export default logger;
